import { render } from "./CompanyItemsList.vue?vue&type=template&id=4a9aa79d"
import script from "./CompanyItemsList.vue?vue&type=script&lang=js"
export * from "./CompanyItemsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__